var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6lzjysb1ta",
    d: "M9 0c1.243 0 2.25 1.007 2.25 2.25v.749l3 .001c.38 0 .693.282.743.648L15 3.75c0 .414-.336.75-.75.75l-.75-.001v9.751c0 1.19-.925 2.166-2.096 2.245l-.154.005h-7.5c-1.243 0-2.25-1.007-2.25-2.25l-.001-9.751L.75 4.5c-.38 0-.693-.282-.743-.648L0 3.75C0 3.336.336 3 .75 3l3-.001V2.25c0-1.19.925-2.166 2.096-2.245L6 0zM4.485 4.5l-1.486-.001L3 14.25c0 .38.282.693.648.743L3.75 15h7.5c.414 0 .75-.336.75-.75V4.499h-1.486L10.5 4.5h-.015l-5.971-.001L4.5 4.5h-.015zM6 6.75c.414 0 .75.336.75.75V12c0 .414-.336.75-.75.75s-.75-.336-.75-.75V7.5c0-.414.336-.75.75-.75zm3 0c.414 0 .75.336.75.75V12c0 .414-.336.75-.75.75s-.75-.336-.75-.75V7.5c0-.414.336-.75.75-.75zM9 1.5H6c-.414 0-.75.336-.75.75v.749h4.5V2.25c0-.38-.282-.693-.648-.743L9 1.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-503 -245) translate(238 213) translate(265 32)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2B00E3",
    fillRule: "nonzero",
    xlinkHref: "#6lzjysb1ta"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.9cd032837ef1ad6918212b4a5b68ebd8.svg";
export { ForwardRef as ReactComponent };